import { Component, DoCheck } from '@angular/core';
import { CoreBuildingBlockControlBaseComponent } from '../../shared/building-block-control-base.component';
import { CoreBuildingBlock } from '../../shared/building-block.decorator';

@CoreBuildingBlock('field-group')
@Component({
  selector: 'cu-field-group',
  templateUrl: './field-group.component.html'
})
export class FieldGroupComponent extends CoreBuildingBlockControlBaseComponent implements DoCheck {
  public hasRowValueGroup(id: string): boolean {
    return id.includes('row-value-group') ? true : false;
  }

  /**
   * Make the Field Group to dirty when any of its nested controls are in dirty.
   */
  ngDoCheck(): void {
    this.field.dirty = this.field.nestedFields && this.field.nestedFields.filter((f) => f.dirty).length > 0;
  }
}
